/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Focal_LengthInputs */

const en_image_inspector_focal_length = /** @type {(inputs: Image_Inspector_Focal_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focal length`)
};

const ar_image_inspector_focal_length = /** @type {(inputs: Image_Inspector_Focal_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البعد البؤري`)
};

const bn_image_inspector_focal_length = /** @type {(inputs: Image_Inspector_Focal_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফোকাল লেংথ`)
};

const de_image_inspector_focal_length = /** @type {(inputs: Image_Inspector_Focal_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brennweite`)
};

const es_image_inspector_focal_length = /** @type {(inputs: Image_Inspector_Focal_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distancia focal`)
};

const fr_image_inspector_focal_length = /** @type {(inputs: Image_Inspector_Focal_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focale`)
};

const pt_image_inspector_focal_length = /** @type {(inputs: Image_Inspector_Focal_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distância focal`)
};

const zh_image_inspector_focal_length = /** @type {(inputs: Image_Inspector_Focal_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`焦距`)
};

const tr_image_inspector_focal_length = /** @type {(inputs: Image_Inspector_Focal_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odak uzaklığı`)
};

const ru_image_inspector_focal_length = /** @type {(inputs: Image_Inspector_Focal_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фокусное расстояние`)
};

const pl_image_inspector_focal_length = /** @type {(inputs: Image_Inspector_Focal_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogniskowa`)
};

/**
* | output |
* | --- |
* | "Focal length" |
*
* @param {Image_Inspector_Focal_LengthInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_focal_length = /** @type {((inputs?: Image_Inspector_Focal_LengthInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Focal_LengthInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_focal_length(inputs)
	if (locale === "bn") return bn_image_inspector_focal_length(inputs)
	if (locale === "de") return de_image_inspector_focal_length(inputs)
	if (locale === "es") return es_image_inspector_focal_length(inputs)
	if (locale === "fr") return fr_image_inspector_focal_length(inputs)
	if (locale === "pt") return pt_image_inspector_focal_length(inputs)
	if (locale === "zh") return zh_image_inspector_focal_length(inputs)
	if (locale === "tr") return tr_image_inspector_focal_length(inputs)
	if (locale === "ru") return ru_image_inspector_focal_length(inputs)
	if (locale === "pl") return pl_image_inspector_focal_length(inputs)
	return en_image_inspector_focal_length(inputs)
});